<template>
  <a-modal
  :maskClosable="false"
    :visible="visible"
    title="重置密码"
    :confirmLoading="confirmLoading"
    @ok="save"
    @cancel="cancel"
    destroyOnClose
  >
  <p>密码将被重置为：zhlc123</p>
  </a-modal>
</template>
<script>
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      confirmLoading: false,
      visible: true
    }
  },
  methods: {
    async save () {
      let isError = false
      this.$loading.show()
      this.confirmLoading = true
      try {
        await this.$tkParse.put(`/classes/_User/${this.record.objectId}`, {
          password: 'zhlc123'
        })
        this.vm.refresh()
        this.$notification['success']({
          message: '操作成功',
          description: '密码重置成功'
        })
        this.visible = false
        this.$emit('complete')
      } catch (e) {
        console.log(e)
        if (!isError) {
          this.$notification['error']({
            message: '操作失败',
            description: '操作失败，请重试'
          })
        }
      }
      this.confirmLoading = false
      this.$loading.hide()
    },
    cancel () {
      this.visible = false
    }
  }
}
</script>
<style scoped>
/* ::v-deep .ant-modal-body{
  display: none;
}
::v-deep .ant-modal-header{
  border: none;
}

::v-deep .ant-modal-footer{
  border: none;
} */
</style>
